import { render } from "./YoungkingScreen.vue?vue&type=template&id=220bf947&scoped=true&ts=true&lang=pug"
import script from "./YoungkingScreen.vue?vue&type=script&lang=ts"
export * from "./YoungkingScreen.vue?vue&type=script&lang=ts"

import "./YoungkingScreen.vue?vue&type=style&index=0&id=220bf947&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220bf947"]])

export default __exports__